export default "__VITE_ASSET__DMgIIZZR__"